"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeSrc = exports.decodeSrc = exports.removeKeys = exports.removeKey = void 0;
const removeKey = (obj, key) => {
    const copied = Object.assign({}, obj);
    delete copied[key];
    return copied;
};
exports.removeKey = removeKey;
const removeKeys = (obj, keys) => {
    const copied = Object.assign({}, obj);
    for (const key of keys) {
        delete copied[key];
    }
    return copied;
};
exports.removeKeys = removeKeys;
const decodeSrc = (src) => {
    const parsedUrl = parseUrl(src);
    const { protocol, host, path, searchParams } = parseUrl(src);
    if (src && protocol === "data") {
        const contentTypeMatch = src.match(/data:([a-z0-9/+-]+);/);
        const contentType = contentTypeMatch ? contentTypeMatch[1] : undefined;
        return {
            protocol,
            contentType,
            url: src,
        };
    }
    else {
        const { contentType } = extractParams(searchParams, ["contentType"]);
        return {
            protocol,
            host,
            path,
            contentType,
            url: src ? unparseUrl(parsedUrl) : undefined,
        };
    }
};
exports.decodeSrc = decodeSrc;
const encodeSrc = (obj) => {
    const { protocol, host, path, contentType, name, url: urlString } = obj;
    const url = parseUrl(urlString || `${protocol}://${host}${path}`);
    if (url.searchParams) {
        mergeParams(url.searchParams, { contentType, name });
        return unparseUrl(url);
    }
    else {
        // data URL
        return urlString;
    }
};
exports.encodeSrc = encodeSrc;
const parseUrl = (src) => {
    var _a, _b;
    const match = (_a = src === null || src === void 0 ? void 0 : src.match) === null || _a === void 0 ? void 0 : _a.call(src, /^([a-z-]+):\/\/([a-z0-9.-]+)([^?#]+)(?:\?([^#]+))?/);
    if (match) {
        const [_, protocol, host, path, search] = match;
        return {
            protocol,
            host,
            path,
            searchParams: new URLSearchParams(search),
        };
    }
    const matchNohost = (_b = src === null || src === void 0 ? void 0 : src.match) === null || _b === void 0 ? void 0 : _b.call(src, /^([a-z-]+):(.*)/);
    if (matchNohost) {
        const [_, protocol, path] = matchNohost;
        return { protocol, path };
    }
    return {};
};
const unparseUrl = ({ protocol, host, path, searchParams, }) => {
    const searchString = searchParams === null || searchParams === void 0 ? void 0 : searchParams.toString();
    return `${protocol}://${host}${path}${searchString ? "?" : ""}${searchString}`;
};
const mergeParams = (params, obj) => {
    for (const [key, value] of Object.entries(obj)) {
        if (value) {
            params.append(key, value);
        }
    }
};
const extractParams = (params, keys) => {
    const obj = {};
    if (params) {
        for (const key of keys) {
            const value = params.get(key);
            if (value) {
                obj[key] = value;
            }
            params.delete(key);
        }
    }
    return obj;
};
